import React, { useCallback, useEffect, useState } from 'react';
import { Button, Loader, Text } from '@vymo/ui/atoms';
import { SCRIPT_PATHS } from '../constants';
import { Platform } from '../viewportMockWrapper/types';
import styles from '../index.module.scss';

let scriptInitialized = false;

interface PlatformRendererProps {
  platform: Platform;
  width: number;
  height: number;
}

function WebPlatformRenderer({
  platform,
  width,
  height,
}: PlatformRendererProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const renderApp = useCallback(() => {
    if (platform === 'web' || platform === 'selfserve') {
      if (window.vymo?.default) {
        window.vymo.default.render('mockApp', 'renderPlatform');
        setLoading(false);
      }
    }
  }, [platform]);

  useEffect(() => {
    if (
      (platform === 'web' || platform === 'selfserve') &&
      !scriptInitialized
    ) {
      setLoading(true);
      const scriptPath = SCRIPT_PATHS[platform];

      if (scriptPath) {
        const script = document.createElement('script');
        script.src = scriptPath;
        script.async = true;
        script.onerror = () => {
          setError(`Failed to load ${platform} platform`);
          setLoading(false);
        };

        window.initializePage = renderApp;
        scriptInitialized = true;
        document.head.appendChild(script);
      }
    } else {
      renderApp();
    }

    return () => {
      if (platform === 'web' || platform === 'selfserve') {
        window.vymo?.default?.unmount?.();
        window.hostApp = null;
      }
    };
  }, [platform, renderApp]);

  if (error) {
    return (
      <div className={styles.error}>
        <Text type="h3">Platform Load Error</Text>
        <Text>{error}</Text>
        <Button onClick={() => window.location.reload()}>Retry</Button>
      </div>
    );
  }

  return (
    <Loader visible={loading}>
      <div
        className={styles.viewport}
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        <div id="renderPlatform" />
      </div>
    </Loader>
  );
}

export default WebPlatformRenderer;
